import qs from 'query-string';

import { SalesTypes } from 'context/entityContext';
import { sortOrderTypes } from 'types/shared';

type CustomerFiltersType = 'streaming' | 'download' | 'charts' | 'country';

interface IArtistRelationsURLArgs {
  entityId: number;
  salesType?: SalesTypes;
  customerFilter?: CustomerFiltersType;
  sortOrder?: sortOrderTypes;
  sortby?: string;
  countryIds?: string[];
  limit?: number;
  offset?: number;
  expand?: string;
}

export default function getArtistRelationsURL(
  args: IArtistRelationsURLArgs
): string {
  const {
    entityId,
    salesType,
    customerFilter,
    sortOrder,
    sortby,
    countryIds,
    limit,
    offset,
    expand,
  } = args;

  const params = qs.stringify({
    salesType,
    customerFilter,
    sortOrder,
    sortby,
    countryIds,
    limit,
    offset,
    expand,
  });

  return `/api/browse/artist/${entityId}/relations?${params}`;
}
